import Modal from '../ui/Modal';
import Btn from '../ui/Button';
import { useSettings } from '../../context/SettingsContext';
import en from '../../locales/en.json';
import hi from '../../locales/hi.json';
import gu from '../../locales/gu.json';

const translations = { en, hi, gu };

export default function LogoutModal({ onConfirm, onCancel }) {
  const { language = 'en' } = useSettings();
  const t = (key) => translations[language]?.common?.[key] || translations.en?.common?.[key] || key;
  return (
    <Modal title={t("title_confirm_logout")} onClose={onCancel} wide>
      <p className="text-sm text-slate-600 dark:text-slate-400 mb-5">{t("msg_logout_confirm")}</p>
      <div className="flex gap-2 justify-end">
        <Btn onClick={onCancel}>{t("btn_cancel")}</Btn>
        <Btn variant="danger" onClick={onConfirm}>{t("btn_logout")}</Btn>
      </div>
    </Modal>
  );
}
